<template>
  <component :is="componentName"></component>
</template>

<script>
const billingCenterAdmin = () =>
  import("@/views/form/billingCenter/billingCenterAdmin.vue");
const billingCenterCommon = () =>
  import("@/views/form/billingCenter/billingCenterCommon.vue");

export default {
  components: {
    billingCenterAdmin,
    billingCenterCommon
  },
  data() {
    return {
      componentName: "billingCenterAdmin"
    };
  },
  created() {
    this.getAccountMangement();
  },
  methods: {
    getAccountMangement() {
      let currentUser = this.$store.state.login.currentUser;
      if (currentUser) {
        this.componentName =
            currentUser.tenantId === "-1"
            ? "billingCenterAdmin"
            : "billingCenterCommon";
      }
    }
  }
};
</script>

<style scoped>
.payDetail {
  border: 1px solid #e4e7ed;
  height: 6rem;
  padding: 10px;
}

.pay_title {
  font-weight: bold;
  color: black;
  font-size: larger;
}

.bottom_row {
  height: 2rem;
  text-align: left;
  display: flex;
  align-items: center;
}

.pay_content {
  font-weight: bold;
  color: #3b97d7;
  font-size: larger;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: calc(25% - 13px);
  float: left;
  margin-top: 10px;
  margin-right: 10px;
}

.bottom {
  text-align: right;
}

.drawer_content {
  padding: 0px 20px;
}

.noData_tips {
  height: 100%;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
}
</style>
